export default __webpack_public_path__ + "static/media/AcompanhamentoDeSala.ed87cb94.svg";